<template>
    <div class="saas-page profile-command-page">
        <div class="saas-hero card-saas profile-command-hero">
            <div class="saas-hero__main">
                <p class="saas-hero__crumb">
                    <router-link to="/user">{{ trans('user.user') }}</router-link>
                    <span class="px-1">/</span>
                    <span>{{ trans('user.social') }}</span>
                </p>
                <h1 class="saas-hero__title">{{ userForm.first_name }} {{ userForm.last_name }}</h1>
                <p class="profile-command-hero__subtitle">{{ trans('user.social') }}</p>
            </div>
        </div>

        <div class="nk-block">
            <div class="card-saas card-saas--flush admin-user-profile-card">
                <div class="card-aside-wrap">
                    <div class="card-content">
                        <user-sidebar menu="social" :id="id"></user-sidebar>
                        <div class="card-inner admin-user-form-inner">
                            <div class="nk-block">
                                <div class="nk-block-head admin-user-form-head">
                                    <h4 class="admin-user-section-title">{{trans('user.social')}}</h4>
                                </div>
                                <form @submit.prevent="submit" @keydown="userForm.errors.clear($event.target.name)">
                                    <div class="row">
                                        <div class="col-12 col-md-6 form-group">
                                            <label for="">{{trans('user.sm_profile',{name: 'Facebook'})}}</label>
                                            <input class="form-control" type="text" value="" v-model="userForm.facebook_profile" name="facebook_profile" :placeholder="trans('user.sm_profile',{name: 'Facebook'})">
                                            <show-error :form-name="userForm" prop-name="facebook_profile"></show-error>
                                        </div>
                                        <div class="col-12 col-md-6 form-group">
                                            <label for="">{{trans('user.sm_profile',{name: 'Twitter'})}}</label>
                                            <input class="form-control" type="text" value="" v-model="userForm.twitter_profile" name="twitter_profile" :placeholder="trans('user.sm_profile',{name: 'Twitter'})">
                                            <show-error :form-name="userForm" prop-name="twitter_profile"></show-error>
                                        </div>
                                        <div class="col-12 col-md-6 form-group">
                                            <label for="">{{trans('user.sm_profile',{name: 'LinkedIn'})}}</label>
                                            <input class="form-control" type="text" value="" v-model="userForm.linkedin_profile" name="linkedin_profile" :placeholder="trans('user.sm_profile',{name: 'LinkedIn'})">
                                            <show-error :form-name="userForm" prop-name="linkedin_profile"></show-error>
                                        </div>
                                        <div class="col-12 col-md-6 form-group">
                                            <label for="">{{trans('user.sm_profile',{name: 'Google Plus'})}}</label>
                                            <input class="form-control" type="text" value="" v-model="userForm.google_plus_profile" name="google_plus_profile" :placeholder="trans('user.sm_profile',{name: 'Google Plus'})">
                                            <show-error :form-name="userForm" prop-name="google_plus_profile"></show-error>
                                        </div>
                                    </div>
                                    <div class="admin-user-form-actions">
                                        <button type="submit" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid">{{trans('general.save')}}</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="card-aside card-aside-right user-aside toggle-slide toggle-slide-right toggle-break-xxl" data-content="userAside" data-toggle-screen="xxl" data-toggle-overlay="true" data-toggle-body="true">
                        <div class="card-inner-group" data-simplebar>
                            <user-summary :user="user"></user-summary>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import userSidebar from './user-sidebar'
    import userSummary from './summary'

    export default {
        components : { userSidebar,userSummary },
        data() {
            return {
                id:this.$route.params.id,
                userForm: new Form({
                    facebook_profile: '',
                    twitter_profile: '',
                    linkedin_profile: '',
                    google_plus_profile: '',
                    first_name: '',
                    last_name: '',
                },false),
                user: ''
            };
        },
        mounted(){
            if(!helper.hasPermission('edit-user')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            axios.get('/api/user/'+this.id)
                .then(response => response.data)
                .then(response => {
                    this.user = response.user;
                    this.userForm.facebook_profile = response.user.profile.facebook_profile;
                    this.userForm.twitter_profile = response.user.profile.twitter_profile;
                    this.userForm.linkedin_profile = response.user.profile.linkedin_profile;
                    this.userForm.google_plus_profile = response.user.profile.google_plus_profile;
                    this.userForm.first_name = response.user.profile.first_name;
                    this.userForm.last_name = response.user.profile.last_name;
                })
                .catch(error => {
                    helper.showDataErrorMsg(error);
                    this.$router.push('/user');
                })
        },
        methods: {
            submit(){
                this.userForm.patch('/api/user/'+this.id+'/social')
                    .then(response => {
                        toastr.success(response.message);
                        this.user.profile.facebook_profile = this.userForm.facebook_profile;
                        this.user.profile.twitter_profile = this.userForm.twitter_profile;
                        this.user.profile.linkedin_profile = this.userForm.linkedin_profile;
                        this.user.profile.google_plus_profile = this.userForm.google_plus_profile;
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            }
        }
    }
</script>

<style scoped>
.profile-command-page {
    --linear-accent: #625cf6;
    --linear-line: #e5e7eb;
    --linear-muted: #64748b;
}

.profile-command-hero,
.admin-user-profile-card {
    border-color: var(--linear-line);
    background: #ffffff;
}

.profile-command-hero__subtitle {
    margin: 0.25rem 0 0;
    color: var(--linear-muted);
    font-size: 0.8125rem;
    font-weight: 500;
}

.admin-user-form-inner {
    background: transparent;
}

.admin-user-section-title {
    color: #0f172a;
    font-weight: 600;
    letter-spacing: -0.02em;
}

.admin-user-form-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 0.5rem;
}
</style>
